// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2jS4u","noInteraction":"EventWrapper_noInteraction__1SNNA","pointerPassthrough":"EventWrapper_pointerPassthrough__3ZsWA"};